import { render, staticRenderFns } from "./EditTemplateForm.vue?vue&type=template&id=762061ad&"
import script from "./EditTemplateForm.vue?vue&type=script&lang=js&"
export * from "./EditTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports